import React from 'react';
import styles from './ExpensesMonthly.scss';

const HoverText = ({ children }) => (
  <div className={styles.onMouseHover}>
    <div className={styles.hoverContent}>{children}</div>
  </div>
);

export default HoverText;
